/**
 * Normaliza un nombre a snake_case ASCII (sin acentos ni símbolos).
 * Devuelve 'custom' si el resultado quedara vacío.
 */
export function slugifyDocType(name: string): string {
  const slug = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // quita acentos
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')     // no-alfanumérico -> _
    .replace(/^_+|_+$/g, '')          // trim de _
  return slug || 'custom'
}

/**
 * Genera un id snake_case único frente a los ids ya existentes.
 * Si el slug colisiona, añade sufijo incremental (_2, _3, ...).
 */
export function generateUniqueDocTypeId(nameEs: string, existingIds: string[]): string {
  const base = slugifyDocType(nameEs)
  const taken = new Set(existingIds)
  if (!taken.has(base)) return base
  let n = 2
  while (taken.has(`${base}_${n}`)) n++
  return `${base}_${n}`
}
